export const egyptsResearch = [
    { name: "Ash Warden", wood: 790, clay: 500, iron: 1360, crop: 520, all: 3170 },
    { name: "Khopesh Warrior", wood: 1120, clay: 820, iron: 1960, crop: 640, all: 4540 },
    { name: "Sopdu Explorer", wood: 1120, clay: 700, iron: 360, crop: 400, all: 2580 },
    { name: "Anhur Guard", wood: 2260, clay: 1420, iron: 2440, crop: 880, all: 7000 },
    { name: "Resheph Chariot", wood: 2800, clay: 2340, iron: 5080, crop: 1240, all: 11460 },
    { name: "Ram", wood: 6070, clay: 2400, iron: 2920, crop: 640, all: 12030 },
    { name: "Stone Catapult", wood: 5980, clay: 6140, iron: 5480, crop: 760, all: 18360 },
    { name: "Nomarch", wood: 17500, clay: 25200, iron: 27600, crop: 25360, all: 95660 }
]